export const recaptchaConfig = {
  scriptUrl: "https://www.google.com/recaptcha/api.js",
  verifyUrl: "/api/recaptcha/verify"
} as const;

export type RecaptchaConfig = typeof recaptchaConfig;
